import './index.scss';
import React from 'react';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import store from './services/redux/store'
import { createRoot } from 'react-dom/client';

// Suppress ResizeObserver loop errors - these are benign warnings from libraries like AG Grid
const originalError = console.error;
console.error = (...args) => {
    if (
        typeof args[0] === 'string' &&
        args[0].includes('ResizeObserver loop completed with undelivered notifications')
    ) {
        return;
    }
    originalError.apply(console, args);
};

// Suppress ResizeObserver errors in window error handler
const originalErrorHandler = window.onerror;
window.onerror = (message, source, lineno, colno, error) => {
    if (
        typeof message === 'string' &&
        message.includes('ResizeObserver loop completed with undelivered notifications')
    ) {
        return true; // Suppress the error
    }
    if (originalErrorHandler) {
        return originalErrorHandler(message, source, lineno, colno, error);
    }
    return false;
};

// Suppress ResizeObserver errors in unhandled promise rejections
window.addEventListener('error', (event) => {
    if (
        event.message &&
        event.message.includes('ResizeObserver loop completed with undelivered notifications')
    ) {
        event.preventDefault();
        return true;
    }
    return false;
}, true);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <Provider store={store}>
        <App />
    </Provider>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();